import { useState } from 'react';
import { Button } from './Button';
import { Champ } from './Champ';
import { ErreurFormulaire } from './Formulaire';
import { Modale } from './Modale';

/**
 * Demande confirmation avant une suppression ; l'erreur éventuelle s'affiche
 * dans la fenêtre. `aRetaper` : pour une suppression lourde et irréversible,
 * le bouton n'agit qu'une fois ce texte (le nom de la fiche) retapé.
 */
export function Confirmation({
  titre,
  message,
  libelleAction = 'Supprimer',
  aRetaper,
  onConfirmer,
  onFermer,
}: {
  titre: string;
  message: string;
  libelleAction?: string;
  aRetaper?: string | undefined;
  onConfirmer: () => Promise<void>;
  onFermer: () => void;
}) {
  const [envoi, setEnvoi] = useState(false);
  const [erreur, setErreur] = useState<string | null>(null);
  const [saisie, setSaisie] = useState('');
  const normaliser = (s: string) => s.trim().replace(/\s+/g, ' ').toLowerCase();
  const confirme = !aRetaper || normaliser(saisie) === normaliser(aRetaper);

  async function confirmer() {
    if (!confirme) {
      setErreur('Retapez le nom exactement pour confirmer.');
      return;
    }
    setEnvoi(true);
    setErreur(null);
    try {
      await onConfirmer();
      onFermer();
    } catch (e) {
      setErreur(e instanceof Error ? e.message : 'La suppression n’a pas abouti.');
      setEnvoi(false);
    }
  }

  return (
    <Modale
      titre={titre}
      onFermer={onFermer}
      pied={
        <>
          <Button onClick={onFermer}>Annuler</Button>
          <Button
            data-autofocus={aRetaper ? undefined : true}
            disabled={envoi || !confirme}
            onClick={() => void confirmer()}
            className="border-danger bg-danger text-white hover:bg-danger/90"
          >
            {envoi ? 'Suppression…' : libelleAction}
          </Button>
        </>
      }
    >
      <p className="text-[13px] whitespace-pre-line text-muted">{message}</p>
      {aRetaper ? (
        <div className="mt-3">
          <Champ
            libelle={`Pour confirmer, tapez : ${aRetaper}`}
            value={saisie}
            autoComplete="off"
            data-autofocus
            onChange={(e) => {
              setSaisie(e.target.value);
              setErreur(null);
            }}
          />
        </div>
      ) : null}
      <ErreurFormulaire message={erreur} />
    </Modale>
  );
}
